import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";
import { Post } from "./post.model";
import { Posts } from "./posts.model";
import { ParcialPost } from "./parcialpost.model";

@Injectable({ providedIn: "root" })
export class PostsService {
  private posts: Post[] = [];
  private postsUpdated = new Subject<Post[]>();

  constructor(private http: HttpClient, private router: Router) { }

  getPosts() {
    //https://blog-project-api-khaki.vercel.app
    this.http
      .get<{ message: string; posts: any }>("https://blog-project-api-khaki.vercel.app/api/posts")
      .pipe(
        map(postData => {
          return postData.posts.map(post => {
            return {
              title: post.title,
              content: post.content,
              id: post._id,
              photo: {
                url: post.photo.url,
                filename: post.photo.filename
              }
            };
          });
        })
      )
      .subscribe(transformedPosts => {
        this.posts = transformedPosts;
        this.postsUpdated.next([...this.posts]);
      });
  }

  getPostUpdateListener() {
    return this.postsUpdated.asObservable();
  }

  getPost(id: string): Observable<Posts[]> {
    return this.http.get<Posts[]>("https://blog-project-api-khaki.vercel.app/api/posts/" + id);
  }

  addPost(title: string, content: string, image: File) {
    const formData = new FormData()
    formData.append("title", title);
    formData.append("content", content);
    formData.append(
      'file',
      image,
      image.name
    )
    this.http.post<{ message: string; post: Post }>('https://blog-project-api-khaki.vercel.app/api/posts', formData, {}).subscribe(responseData => {
      // const post: Post = {
      //   id: responseData.post.id,
      //   title: title,
      //   content: content,
      //   photo: {
      //     url: responseData.post.photo.url,
      //     filename: responseData.post.photo.filename
      //   }
      // };
      this.posts.push(responseData.post);
      this.postsUpdated.next([...this.posts]);
      this.router.navigate(["/"]);
    });
  }

  updatePost(id: string, title: string, content: string, image: File) {
    // let postData: Post | FormData;
    // if (typeof image === "object") {
      console.log(image)
    const postData = new FormData();
    postData.append("id", id);
    postData.append("title", title);
    postData.append("content", content);
    postData.append(
      'file',
      image,
      image.name
    )
    this.http
      .put<{ message: string; post: Post }>("https://blog-project-api-khaki.vercel.app/api/posts/" + id, postData)
      .subscribe(response => {
        console.log(response)
        const updatedPosts = [...this.posts];
        const oldPostIndex = updatedPosts.findIndex(p => p.id === id);
        updatedPosts[oldPostIndex] = response.post;
        this.posts = updatedPosts;
        this.postsUpdated.next([...this.posts]);
        this.router.navigate(["/"]);
      });
  }

  updatePost2(id: string, title: string, content: string) {
    // let postData: Post | FormData;
    // if (typeof image === "object") {
      console.log(title)
    const postData = {
      'id':id,
      'title':title,
      'content':content
    }
  
    this.http
      .patch<{ message: string; post: ParcialPost }>("https://blog-project-api-khaki.vercel.app/api/posts/" + id, postData)
      .subscribe(response => {
        console.log(response)
        const updatedPosts = [...this.posts];
        const oldPostIndex = updatedPosts.findIndex(p => p.id === id);
        // updatedPosts[oldPostIndex] = response.post;
        this.posts = updatedPosts;
        this.postsUpdated.next([...this.posts]);
        this.router.navigate(["/"]);
      });
  }


  deletePost(postId: string) {
    this.http
      .delete("https://blog-project-api-khaki.vercel.app/api/posts/" + postId)
      .subscribe(() => {
        const updatedPosts = this.posts.filter(post => post.id !== postId);
        this.posts = updatedPosts;
        this.postsUpdated.next([...this.posts]);
      });
  }
}
